module.exports = __webpack_public_path__ + "static/media/arrow3.eb55e35e.png";